import React from 'react';
import { Row } from 'react-bootstrap';
import i18n from 'utils/I18n';
import { connect } from 'react-redux';

import Addition from 'assets/images/addition.svg';
import Subtraction from 'assets/images/subtraction.svg';

import RequiredPointsInfo from 'component/ticket/RequiredPointsInfo';
import { enLocaleNumberFormatter } from 'utils';
import "./QuantitySelector.scss"

const mapStateToProps = ({ users }) => ({
});

const QuantitySelector = ({
  language,
  isConfirm,
  count,
  btnMinusDisable,
  btnAddDisable,
  countMinus,
  countAdd,
  isRequiredPoints = false,
  requiredPoints,
}) => {
  const totalPointsToUse = requiredPoints * count;
  return (
    <div className={`quantity_selector_container ${isRequiredPoints ? "no-padding-bottom" : ""}`}>
      {isRequiredPoints &&
        <Row>
          <label className="block_label headline">{i18n.t('point_required')}</label>
          <label className="required_points title-medium-2">
            {`${enLocaleNumberFormatter(requiredPoints)} ${i18n.t('points')}`}
          </label>
        </Row>
      }
      <Row>
        <label className="block_label headline">{i18n.t('campaign_quantity')}</label>
      </Row>
      {isConfirm ?
        <Row>
          <label className="required_points title-medium-2">
            {enLocaleNumberFormatter(count)}
          </label>
        </Row> :
        <Row className="quantity_row">
          <button
            className="reduce_btn"
            onClick={countMinus}
            disabled={btnMinusDisable}
          >
            <img
              alt="minus"
              src={Subtraction}
              className="icon"
            ></img>
          </button >
          <label className="numbers title-large">{count}</label>
          <button
            className="multiply_btn justify-content-end"
            onClick={countAdd}
            disabled={btnAddDisable}
          >
            <img
              alt="multiply"
              src={Addition}
              className="icon"
            />
          </button>
        </Row>
      }
      {isRequiredPoints &&
        <RequiredPointsInfo totalPointsToUse={totalPointsToUse} />
      }
    </div>
  )
};
export default connect(mapStateToProps)(QuantitySelector);
